<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  <input formControlName="id" type="hidden" />

  @if (submitErrorMessages.length) {
    <pr-color-panel display="danger" clazz="mbm">
      <pr-panel-body clazz="pam">
        <div role="alert">
          <ul class="submit-errors">
            @for (message of submitErrorMessages; track message) {
              <li>{{ message }}</li>
            }
          </ul>
        </div>
      </pr-panel-body>
    </pr-color-panel>
  }

  <h3 class="drawer-title">Informations générales</h3>

  <div class="form-sct-container">
    <!-- Credit name (label) -->
    <pr-input label="Nom du crédit" [derrors]="derrors">
      <input formControlName="label" type="text" />
    </pr-input>

    <!-- Category (category) -->
    <pr-input label="Catégorie" [derrors]="derrors">
      <mat-select formControlName="category">
        @for (category of loanCategories; track category) {
          <mat-option [value]="category.id">
            {{ category.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <pr-input label="Banque" [derrors]="derrors">
      <mat-select
        formControlName="providerId"
        (selectionChange)="onBanqueChange($event)"
      >
        @for (provider of providers; track provider) {
          <mat-option [value]="provider.id">
            {{ provider.name }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    @if (form.get('providerId').value) {
      <pr-input label="Agence bancaire" [derrors]="derrors">
        <mat-select formControlName="agenceBancaireId">
          @for (
            agenceBancaire of agencesBancairesFiltered;
            track agenceBancaire
          ) {
            <mat-option [value]="agenceBancaire.id">
              {{ agenceBancaire.codeGuichet }} -
              {{ agenceBancaire.ville }}
            </mat-option>
          }
        </mat-select>
      </pr-input>
    }

    <!-- Investment Associated to (investmentId) -->
    <pr-input label="Associé à" [derrors]="derrors">
      <mat-select formControlName="investmentId">
        @for (investment of investments; track investment) {
          <mat-option [value]="investment.id">
            {{ investment.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <!-- Détenteurs + part de détention (owners) -->
    <pr-input-owner-share
      formControlName="owners"
      [derrors]="derrors"
    ></pr-input-owner-share>

    <!-- Start Date (startDate) -->
    <pr-input-date
      formControlName="signatureDate"
      label="Date de signature"
      [derrors]="derrors"
    ></pr-input-date>
    <pr-input-date
      formControlName="startDate"
      label="Date de début"
      [derrors]="derrors"
    ></pr-input-date>
  </div>

  <h3 class="drawer-title">Méthode d'ajout</h3>

  <!-- Adding Mode (mode) -->
  <pr-input-radio-round
    formControlName="mode"
    [options]="[
      { value: true, label: 'Mode simple' },
      { value: false, label: 'Mode avancé' },
    ]"
  >
  </pr-input-radio-round>

  <h3 class="drawer-title">Informations du crédit</h3>

  <div class="form-sct-container">
    <!-- Credit type (type) -->
    <pr-input-radio
      [toggleBgEmpty]="true"
      [hidden]="form.get('mode').value"
      formControlName="type"
      label="Type de crédit"
      [options]="[
        { value: 'FIX', label: 'Fixe' },
        { value: 'IN_FINE', label: 'In Fine' },
      ]"
    >
    </pr-input-radio>

    <!-- Amount type (simuChoice) -->
    <pr-input-radio
      [toggleBgEmpty]="true"
      [hidden]="hasPaliers"
      formControlName="simuChoice"
      label="Je connais le montant"
      [options]="[
        { value: true, label: 'Emprunté' },
        { value: false, label: 'Des mensualités' },
      ]"
    >
    </pr-input-radio>

    <!-- Amount Borrowed (amountBorrowed, if simuChoice value is false) -->
    <pr-input
      [hidden]="!form.get('simuChoice').value"
      [label]="'Montant emprunté'"
      [suffix]="'€'"
      [derrors]="derrors"
    >
      <input formControlName="amountBorrowed" type="text" />
    </pr-input>

    <!-- Amount Monthly (amountMonthly, if simuChoice value is true) -->
    <pr-input
      [hidden]="form.get('simuChoice').value || hasPaliers"
      [label]="'Mensualité'"
      [suffix]="'€'"
      [derrors]="derrors"
    >
      <input formControlName="amountMonthly" type="text" />
    </pr-input>

    <!-- Duration Total in Month (durationTotalInMonth) -->
    <pr-input label="Durée totale" suffix="Mois" [derrors]="derrors">
      <input formControlName="durationTotalInMonth" type="number" max="420" />
    </pr-input>

    <!-- Application Fee (amountFee) -->
    <pr-input [label]="'Frais de dossier'" suffix="€" [derrors]="derrors">
      <input formControlName="amountFee" type="text" />
    </pr-input>

    <!-- Interest Rate (interestRate) -->
    <pr-input label="Taux d'intérêt" suffix="%" [derrors]="derrors">
      <input formControlName="interestRate" type="text" />
    </pr-input>
  </div>

  @if (paliersNoticeMessage) {
    <pr-color-panel display="warning" clazz="mbm">
      <pr-panel-body clazz="pam">
        <pr-label name="info_outline" [width]="18" [height]="18">
          {{ paliersNoticeMessage }}
        </pr-label>
      </pr-panel-body>
    </pr-color-panel>
  }

  <div [hidden]="!isPaliersAvailable">
    <h3 class="drawer-title">Paliers</h3>

    <div class="form-sct-container">
      <ea-loan-paliers
        [form]="form"
        [derrors]="derrors"
        [startDate]="form.get('startDate').value"
      ></ea-loan-paliers>
    </div>
  </div>

  <div [hidden]="form.get('mode').value">
    <h3 class="drawer-title">Informations de l'assurance</h3>
  </div>

  <div class="form-sct-container">
    <!-- Insurance Calculation Type (insuranceType) -->
    <pr-input-radio
      [toggleBgEmpty]="true"
      [hidden]="form.get('mode').value || form.get('type').value === 'IN_FINE'"
      formControlName="insuranceType"
      label="Calcul de l'assurance"
      [options]="[
        { value: 'AMOUNT_BORROWED', label: 'Sur le Capital Initial' },
        { value: 'LOAN_LEFT', label: 'Sur le Capital restant dû' },
      ]"
    >
    </pr-input-radio>

    <pr-input label="Taux d'assurance" suffix="%" [derrors]="derrors">
      <input formControlName="insuranceRate" type="text" />
    </pr-input>
  </div>

  <div [hidden]="form.get('mode').value">
    <h3 class="drawer-title">Informations sur la quotité</h3>

    <div formArrayName="insuranceQuotite">
      @for (
        quotite of insuranceQuotite.controls;
        track quotite;
        let i = $index
      ) {
        <div class="quotite-container" [formGroupName]="i">
          <pr-input-owner
            formControlName="ownerId"
            [multiple]="false"
            [derrors]="derrors"
          ></pr-input-owner>
          <pr-input label="Quotité" suffix="%" [derrors]="derrors">
            <input formControlName="quotite" type="text" />
          </pr-input>
          @if (canRemoveInsuranceQuotite) {
            <pr-button
              clazz="btn-remove-quotite"
              variant="outline"
              display="danger"
              label="Supprimer"
              (click)="removeInsuranceQuotite(i)"
            />
          }
        </div>
      }
      <pr-button
        display="neutral"
        variant="outline"
        clazz="btn-add-quotite"
        label="Ajouter une quotité"
        (click)="addInsuranceQuotite()"
      />
    </div>
  </div>

  <div [hidden]="form.get('mode').value || hasPaliers">
    <h3 class="drawer-title">Informations sur le différé</h3>
  </div>

  <div class="form-sct-container">
    <!-- Delay Type (differe) -->
    <pr-input-radio
      [toggleBgEmpty]="true"
      [hidden]="form.get('mode').value || hasPaliers"
      formControlName="differe"
      label="Type de différé"
      [options]="[
        { value: 'TOTAL', label: 'Total' },
        { value: 'PARTIEL', label: 'Partiel' },
      ]"
    >
    </pr-input-radio>

    <!-- Delay Duration (durationDiffereInMonth) -->
    <pr-input
      [hidden]="form.get('mode').value || hasPaliers"
      label="Durée du différé"
      suffix="Mois"
      [derrors]="derrors"
    >
      <input formControlName="durationDiffereInMonth" type="text" />
    </pr-input>
  </div>

  <!-- TAEG (shows only for the 'edit credit' form) -->
  @if (entity.taeg != null) {
    <div class="alert alert-success horizontal" role="alert">
      <pr-icon name="checkmark"></pr-icon>
      <div class="bold">{{ entity.taeg * 100 | number: '1.0-2' }}%</div>
      <span>TAEG (Taux annuel effectif global)</span>
    </div>
  }
</pr-form>
